import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h4 className="font-heading text-lg font-bold text-background-50 mb-4">
              {siteInfo.name}
            </h4>
            <p className="text-sm text-background-400 leading-relaxed">
              女神漫画网官网提供海量免费韩漫、日漫、国漫全集阅读服务。每日更新，热门排行榜推荐，支持下拉式在线阅读体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              快速导航
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/hanman" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                  韩漫
                </Link>
              </li>
              <li>
                <Link to="/category/riman" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                  日漫
                </Link>
              </li>
              <li>
                <Link to="/category/guoman" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                  国漫
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              热门标签
            </h4>
            <div className="flex flex-wrap gap-2">
              {['恋爱', '热血', '奇幻', '穿越', '武侠', '战斗', '冒险', '治愈', '职场', '古风'].map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1 text-xs rounded-full bg-background-800 text-background-300 whitespace-nowrap"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              联系我们
            </h4>
            <ul className="space-y-2 text-sm text-background-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>{siteInfo.email}</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <span>{siteInfo.phone}</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line"></i>
                <span>{siteInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="py-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有 | {siteInfo.icp}
          </p>
          <p className="text-xs text-background-500">
            本站所有漫画均来自互联网，版权归原作者所有
          </p>
        </div>
      </div>
    </footer>
  );
}